import { EBENEN, EINSTELLUNGEN, MENUE } from '../../config/ebenen';

// Alle Wörter der Kundenseite des Bereichs (Profil-Nachbau F-06 mit F-19, BAU-HILFE.md 1.1 und 1.3, PF-308-1). Die Komponenten
// unter components/hilfe/ nehmen jedes Wort von hier (Wächter frontend/tests/hilfe-seite.test.mjs, Fall „Texte“). Der Name des
// Bereichs ist MENUE.hilfeUndFeedback und steht nur in config/ebenen.ts; das Fenster schließt seit F-26 über den Knopf
// „Schließen“ der Bereichs-Ebene (components/BereichsSeite.tsx). Wörter späterer Unterseiten (Chat, Tickets, Störungen, Wünsche,
// Organisation) stehen schon hier; ihre Einträge erscheinen erst mit ihren Aufträgen.
export const HILFE_TEXTE = {
  bereich: MENUE.hilfeUndFeedback,
  leiste: {
    dokumente: 'Dokumente',
    chat: 'Chat',
    meineAnfragen: 'Meine Anfragen',
    tickets: 'Tickets',
    stoerungen: 'Störungen',
    wuensche: 'Wünsche',
    neuigkeiten: 'Neuigkeiten',
    // Vorlesetext des Punkts hinter „Tickets“, wenn eine Antwort ungelesen ist.
    neueAntwort: 'Neue Antwort vom Support',
    // PF-323: Vorlesetext des Punkts hinter „Neuigkeiten“ (BAU-HILFE 9.2 Punkt 1).
    ungeleseneNeuigkeiten: 'Ungelesene Neuigkeiten',
  },
  suche: {
    label: 'Hilfe durchsuchen',
    platzhalter: 'Hilfe durchsuchen …',
    leer: 'Nichts gefunden. Fragen Sie den Hilfe-Assistenten im Chat.',
    // F21-3 (FREIGABE F-21): der Hilfe-Assistent ist für Kundinnen und Kunden vorerst aus; ohne Eintrag „Chat“ dieser Satz.
    leerOhneChat: 'Nichts gefunden. Stellen Sie Ihre Frage als Anfrage an den Support.',
  },
  laden: 'Hilfe wird geladen …',
  fehler: 'Die Hilfe ist gerade nicht erreichbar. Bitte versuchen Sie es in einigen Minuten erneut.',
  erneutVersuchen: EINSTELLUNGEN.erneutVersuchen,
  dokumente: {
    titel: 'Dokumente',
    // F-24 (PF-TX-hilfe-1, SPEC-hilfe-b 3.1 U1): eine Unterzeile mit und ohne Chat; der Weg zum Support steht als „Neue Anfrage“
    // im Seitenkopf.
    beschreibung: 'Anleitungen und Antworten zu häufigen Fragen',
    sucheName: 'Anleitungen durchsuchen',
    // F-23 (PF-NB-hilfe-1, Z-04): ein Beispiel, das jede Rolle betrifft (früher „Platz zuweisen“).
    suchePlatzhalter: 'Zum Beispiel: Rechtsfrage stellen',
    imChatFragen: 'Im Chat fragen',
    anleitungen: MENUE.anleitungen,
    weiter: 'Selbst nicht weitergekommen?',
    assistent: 'Hilfe-Assistent',
    assistentErklaerung: 'Beschreiben Sie Ihre Frage. Der Assistent kennt diese Anleitungen.',
    chatOeffnen: 'Chat öffnen',
    neueAnfrage: 'Neue Anfrage',
    datenschutz: MENUE.datenschutz,
    // F-23 (PF-NB-hilfe-1, Z-04): Zwischenüberschriften der Anleitungen; die Gruppe „verwaltung“ nimmt den Begriff der Firma
    // (gruppeVerwaltung unten), die eigenen Dokumente des Betreibers stehen unter „eigene“.
    gruppen: { recherche: 'Recherchieren', konto: 'Ihr Konto', begriffe: 'Begriffe', eigene: 'Weitere Anleitungen' },
  },
} as const;

// PF-309 (BAU-HILFE.md 1.4 wörtlich, F21-4): Wörter des Chats mit dem Hilfe-Assistenten. Die Fehlersätze sind dieselben, die der
// Server sendet (backend/src/support/texte.ts, ASSISTENT_TEXTE); tests/hilfe-chat.test.mjs prüft den Gleichstand.
export const CHAT_TEXTE = {
  titel: 'Chat mit dem Hilfe-Assistenten',
  neueUnterhaltung: 'Neue Unterhaltung',
  leerTitel: 'Fragen Sie den Hilfe-Assistenten',
  // Name des Verlaufs für Bildschirmleser; wer schrieb, steht je Nachricht (Wörter wie die Systemzeilen des Servers).
  verlauf: 'Verlauf',
  sie: 'Sie',
  assistent: 'Hilfe-Assistent',
  feldName: 'Ihre Frage',
  senden: 'Senden',
  ticketAnlegen: 'Ticket anlegen',
  antwortet: 'Der Assistent antwortet …',
  hinweisKi: 'Sie schreiben mit einer KI. KI kann Fehler machen. Verbindlich sind nur Antworten des Supports in einer Anfrage.',
  rechtsfrage: 'Rechtsfragen beantwortet der Hilfe-Assistent nicht. Stellen Sie sie bitte in der Recherche.',
  zurRecherche: 'Zur Recherche',
  vorschlag: 'Soll ich daraus eine Anfrage an den Support machen?',
  neueAnfrage: 'Neue Anfrage',
  nichtErreichbar: 'Der Hilfe-Assistent ist gerade nicht erreichbar. Sie können direkt eine Anfrage an den Support stellen.',
  grenzeTag: 'Sie haben heute schon viele Fragen gestellt. Morgen geht es weiter; dringende Anliegen stellen Sie bitte als Anfrage an den Support.',
  zuLang: 'Diese Unterhaltung ist sehr lang geworden. Bitte beginnen Sie eine neue oder stellen Sie eine Anfrage an den Support.',
  // F21-4: Kostendeckel erreicht; nie ein Betrag.
  deckel: 'Der Hilfe-Assistent ist in diesem Monat nicht mehr verfügbar. Bitte stellen Sie Ihre Frage als Anfrage an den Support.',
  // F21-3: ausgeschaltet; die Seite führt dann zu den Dokumenten, der Satz steht nur, falls sie es nicht kann.
  aus: 'Der Hilfe-Assistent ist gerade ausgeschaltet. Sie können direkt eine Anfrage an den Support stellen.',
} as const;
export const chatLeerText = (produkt: string) =>
  `Beschreiben Sie Ihre Frage oder Ihr Problem mit ${produkt}. Der Assistent antwortet aus den Anleitungen und nennt die passende. Braucht es einen Menschen, bereitet er eine Anfrage an den Support vor.`;
export const chatPlatzhalter = (produkt: string) => `Ihre Frage zu ${produkt} …`;
export const chatLoeschHinweis = (produkt: string) =>
  `${produkt} löscht die Unterhaltung 30 Tage nach der letzten Nachricht und verwendet sie nicht zum Trainieren von KI-Modellen.`;
/** n schon mit Tausenderpunkt („1.800“). */
export const zeichenZaehler = (n: string) => `${n} von 2.000 Zeichen`;
export const grenzeStunde = (minuten: number) =>
  `Sie haben in dieser Stunde schon viele Fragen gestellt. Bitte versuchen Sie es in ${minuten} Minuten wieder oder stellen Sie eine Anfrage an den Support.`;
export const anleitungText = (frage: string) => `Anleitung: „${frage}“`;

// PF-332 (F-21, AUFTRAG-PF-332 „Soll“ 1 wörtlich): Daumen je Antwort des Hilfe-Assistenten.
export const BEWERTUNG_TEXTE = {
  hilfreich: 'Antwort hilfreich',
  nichtHilfreich: 'Antwort nicht hilfreich',
  danke: 'Danke für Ihre Bewertung.',
  fehler: 'Die Bewertung konnte gerade nicht gespeichert werden.',
} as const;

// PF-332 (F-21, AUFTRAG-PF-332 „Soll“ 2 und 3 wörtlich): „Problem bei der Anmeldung?“ auf der Anmeldeseite und die Bestätigung über
// den Link aus der Mail. Die Sätze 429 und 410 sagen dasselbe wie der Server (routes/publicHilfe.ts, support/anmeldeproblem.ts).
// PF-LG-anmeldung-1 (Entwurf 20.10.2026): Auf der Anmeldeseite heißt der Weg dorthin „Hilfe bei der Anmeldung“ (link); die Ansicht
// behält ihren Titel.
export const ANMELDEPROBLEM_TEXTE = {
  titel: 'Problem bei der Anmeldung?',
  link: 'Hilfe bei der Anmeldung',
  einleitung: 'Beschreiben Sie kurz, was nicht klappt. Wir schicken Ihnen eine E-Mail mit einem Link; erst nach Ihrer Bestätigung sieht der Support die Anfrage.',
  email: 'E-Mail-Adresse (Pflicht)',
  beschreibung: 'Was passiert? (Pflicht)',
  hinweis: 'Bitte keine Passwörter oder vertraulichen Inhalte eintragen.',
  senden: 'Anfrage senden',
  sendet: 'Wird gesendet …',
  zurueck: 'Zurück zur Anmeldung',
  erfolgTitel: 'Bitte prüfen Sie Ihr Postfach.',
  erfolgText: 'Wenn die Adresse stimmt, erhalten Sie in wenigen Minuten eine E-Mail mit einem Bestätigungslink. Der Link gilt 60 Minuten.',
  zuViele: 'Zu viele Anfragen von diesem Anschluss. Bitte versuchen Sie es später erneut.',
  fehler: 'Die Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es in einigen Minuten erneut.',
  emailFalsch: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  zuKurz: 'Bitte beschreiben Sie das Problem mit mindestens 10 Zeichen.',
  bestaetigenTitel: 'Anfrage bestätigen',
  bestaetigen: 'Anfrage bestätigen',
  dankeTitel: 'Danke.',
  zurAnmeldung: 'Zur Anmeldung',
  abgelaufen: 'Dieser Link ist abgelaufen oder wurde schon benutzt. Bitte melden Sie das Problem erneut.',
  erneutMelden: 'Problem erneut melden',
  bestaetigenFehler: 'Die Bestätigung ist gerade nicht möglich. Bitte versuchen Sie es in einigen Minuten erneut.',
} as const;
export const anmeldeproblemBestaetigenText = (produkt: string) => `Mit der Bestätigung geht Ihre Anfrage an den Support von ${produkt}.`;
export const anmeldeproblemDanke = (referenz: string) => `Ihre Anfrage ${referenz} ist beim Support. Die Antwort kommt per E-Mail.`;
/** n schon mit Tausenderpunkt („3.600“). */
export const anmeldeproblemZaehler = (n: string) => `${n} von 4.000 Zeichen`;

// PF-311-1 (TEIL-3 SP3-05 „Soll Oberfläche“ wörtlich, BAU-HILFE.md 1.5): Wörter der Störungen, der Hinweisleiste in der App und
// des Hinweises auf der Anmeldeseite. Die Werte-Tabellen decken STOERUNG_STATUS, STOERUNG_AUSWIRKUNG und STOERUNG_BEREICHE aus
// backend/src/support/regeln.ts ab (tests/hilfe-stoerungen.test.mjs prüft das); unbekannte Werte zeigen „—“.
export const STOERUNG_TEXTE = {
  titel: 'Störungen',
  aktuell: 'Aktuell',
  behoben: 'Behoben in den letzten 30 Tagen',
  leerAktuell: 'Derzeit gibt es keine Störungen.',
  leerBehoben: 'In den letzten 30 Tagen wurde keine Störung gemeldet.',
  laden: 'Störungen werden geladen …',
  fehler: 'Die Störungen sind gerade nicht erreichbar. Bitte versuchen Sie es in einigen Minuten erneut.',
  abonnieren: 'Abonnieren',
  abonniert: 'Abonniert',
  aboMail: 'Sie erhalten Updates zu dieser Störung per E-Mail.',
  aboListe: 'Sie erhalten Updates zu dieser Störung hier in der Liste. E-Mails dazu haben Sie in „Benachrichtigungen“ ausgeschaltet.',
  zurueck: 'Zurück zu den Störungen',
  // Überschrift, solange es keinen Titel gibt (Laden, Fehler, unbekannt).
  detailTitel: 'Störung',
  detailLaden: 'Störung wird geladen …',
  meldungen: 'Meldungen',
  betrifftMich: 'Betrifft mich auch – Problem melden',
  details: 'Details',
  ausblenden: 'Ausblenden',
  // Wie backend/src/support/texte.ts FEHLERTEXTE.stoerungFehlt, falls der Server keinen Satz sendet.
  fehlt: 'Diese Störung gibt es nicht.',
  unbekannt: '—',
  status: { UNTERSUCHUNG: 'Wird untersucht', ERKANNT: 'Ursache gefunden', BEOBACHTUNG: 'Behoben, wird beobachtet', BEHOBEN: 'Behoben' } as Record<string, string>,
  auswirkung: { GERING: 'Gering', TEILWEISE: 'Teilweise eingeschränkt', ERHEBLICH: 'Stark eingeschränkt', AUSFALL: 'Ausfall' } as Record<string, string>,
  // Schlusslauf 1 (Befund 13:20, VE-13): das Wort der Ebene „Verwaltung“ steht nur in config/ebenen.ts.
  bereiche: { RECHERCHE: 'Recherche', KOLLEKTIVVERTRAEGE: 'Kollektivverträge', ANMELDUNG: 'Anmeldung', ABRECHNUNG: 'Abrechnung', VERWALTUNG: EBENEN.verwaltung,
    MAIL: 'E-Mails' } as Record<string, string>,
} as const;
/** Das Wort zu einem Wert aus einer der drei Tabellen; ein unbekannter Wert zeigt nie den Rohwert, sondern „—“. */
export const stoerungWort = (tabelle: Record<string, string>, wert: string) => (Object.prototype.hasOwnProperty.call(tabelle, wert) ? tabelle[wert] : STOERUNG_TEXTE.unbekannt);
/** Die betroffenen Bereiche als Wörter, mit Komma getrennt. */
export const stoerungBereiche = (bereiche: string[]) => bereiche.map(bereich => stoerungWort(STOERUNG_TEXTE.bereiche, bereich)).join(', ');
export const stoerungSeit = (datumZeit: string) => `seit ${datumZeit}`;
export const stoerungBehobenAm = (datumZeit: string) => `behoben am ${datumZeit}`;
/** Hinweisleiste in der App: „Störung: {Titel}. {Status}.“ */
export const stoerungLeisteSatz = (titel: string, status: string) => `Störung: ${titel}. ${stoerungWort(STOERUNG_TEXTE.status, status)}.`;
/** Anmeldeseite: fett „Störung: {Titel}.“, daneben „{Status}.“ */
export const stoerungTitelSatz = (titel: string) => `Störung: ${titel}.`;
export const stoerungStatusSatz = (status: string) => `${stoerungWort(STOERUNG_TEXTE.status, status)}.`;

// PF-311-2 (TEIL-3 SP3-06 „Soll Oberfläche“ mit BAU-HILFE.md 1.5 und 9.0 A-11/A-12): Wörter der Wünsche. Statuswörter nach A-11
// decken WUNSCH_STATUS aus backend/src/support/regeln.ts ab (tests/hilfe-wuensche.test.mjs). Kein „Mandant“ außer
// „Mandantendaten“ (Regel K12-4).
export const WUNSCH_TEXTE = {
  titel: 'Wünsche',
  einreichen: 'Wunsch einreichen',
  filterName: 'Filter',
  filter: { oeffentlich: 'Öffentlich', meine: 'Meine', abgestimmt: 'Abgestimmt' },
  sortierungName: 'Sortierung',
  sortierung: { stimmen: 'Meiste Stimmen', neu: 'Neueste', geaendert: 'Zuletzt geändert' },
  suche: 'Wünsche durchsuchen …',
  stimmeGeben: 'Stimme geben',
  stimmeZuruecknehmen: 'Stimme zurücknehmen',
  // Wie backend/src/support/wuensche.ts (WISH_CLOSED).
  abstimmenZu: 'Für diesen Wunsch kann nicht mehr abgestimmt werden.',
  status: { NEU: 'Neu', GEPRUEFT: 'Geprüft', GEPLANT: 'Geplant', UMGESETZT: 'Umgesetzt', ABGELEHNT: 'Abgelehnt', ZUSAMMENGEFUEHRT: 'Zusammengeführt' } as Record<string, string>,
  nurFirma: 'Nur unsere Firma',
  wirdGeprueft: 'Wird geprüft',
  weitere: 'Weitere Wünsche laden',
  leer: 'Noch keine Wünsche. Reichen Sie den ersten ein.',
  leerGefiltert: 'Keine Wünsche in dieser Auswahl.',
  laden: 'Wünsche werden geladen …',
  fehler: 'Die Wünsche sind gerade nicht erreichbar. Bitte versuchen Sie es in einigen Minuten erneut.',
  zurueck: 'Zurück zu den Wünschen',
  // Überschrift, solange es keinen Titel gibt (Laden, Fehler, unbekannt).
  detailTitel: 'Wunsch',
  detailLaden: 'Wunsch wird geladen …',
  // Wie backend/src/support/wuensche.ts (WISH_NOT_FOUND), falls der Server keinen Satz sendet.
  nichtSichtbar: 'Diesen Wunsch gibt es nicht oder er ist für Sie nicht sichtbar.',
  folgen: 'Folgen',
  folgenBeenden: 'Folgen beenden',
  folgenMail: 'Sie erhalten eine E-Mail, wenn sich der Stand ändert.',
  bearbeiten: 'Bearbeiten',
  loeschen: 'Löschen',
  loeschenFrage: 'Wunsch löschen?',
  loeschenText: 'Der Wunsch und Ihre Stimme werden entfernt.',
  abbrechen: 'Abbrechen',
  geloescht: 'Der Wunsch ist gelöscht.',
  neuLaden: 'Neu laden',
  formTitel: 'Wunsch einreichen',
  formTitelBearbeiten: 'Wunsch bearbeiten',
  formLaden: 'Wunsch wird geladen …',
  wofuer: 'Wofür brauchen Sie das?',
  wofuerPlatzhalter: 'Beschreiben Sie, wie Sie heute arbeiten und was sich ändern würde.',
  werSieht: 'Wer soll den Wunsch sehen?',
  hinweis: 'Bitte nennen Sie keine Mandantendaten und keine Namen von Personen.',
  aehnlich: 'Gibt es das schon? Dann geben Sie dort Ihre Stimme.',
  speichern: 'Änderungen speichern',
  verwerfen: 'Verwerfen',
  gespeichert: 'Ihre Änderungen sind gespeichert.',
  laengeTitel: '5 bis 120 Zeichen',
  laengeBeschreibung: '10 bis 4.000 Zeichen',
  steuerzeichen: 'Steuerzeichen sind nicht erlaubt.',
  formFehler: 'Der Wunsch konnte nicht gesendet werden. Ihre Eingaben bleiben erhalten. Bitte versuchen Sie es erneut.',
  schrittFehler: 'Das hat nicht geklappt. Bitte versuchen Sie es erneut.',
  // Namen der Pflichtfelder in „Es fehlt noch: …“.
  fehltTitel: 'Titel',
  fehltBeschreibung: 'Wofür',
} as const;

// Ganze Zahlen mit Tausenderpunkt; Intl setzt für de-AT ein geschütztes Leerzeichen.
const ganzeZahl = (n: number) => n.toLocaleString('de-AT').replace(/[\s\u00a0\u202f]/g, '.');
/** „1 Stimme“, sonst „{n} Stimmen“. */
export const stimmenText = (n: number) => (n === 1 ? '1 Stimme' : `${ganzeZahl(n)} Stimmen`);
/** Statuswort nach A-11; zusammengeführt mit Ziel „Zusammengeführt mit {WUN-…}“; unbekannt „—“. */
export const wunschStatusWort = (status: string, zusammengefuehrtIn: string | null = null) =>
  status === 'ZUSAMMENGEFUEHRT' && zusammengefuehrtIn ? `Zusammengeführt mit ${zusammengefuehrtIn}` : stoerungWort(WUNSCH_TEXTE.status, status);
export const wunschStatusSeit = (status: string, datum: string) => `${status} seit ${datum}`;
export const wunschWasSoll = (produkt: string) => `Was soll ${produkt} können?`;
export const wunschAlleKundenfirmen = (produkt: string) => `Alle Kundenfirmen, nach Prüfung durch ${produkt}`;
export const wunschAntwortVon = (produkt: string) => `Antwort von ${produkt}`;
export const wunschGrund = (grund: string) => `Grund: ${grund}`;
export const wunschAehnlichLink = (titel: string, stimmen: number) => `${titel} (${stimmenText(stimmen)})`;
export const wunschErfolgOeffentlich = (referenz: string) =>
  `Danke. Ihr Wunsch ${referenz} wird geprüft und ist danach für alle Kundenfirmen sichtbar. Ihre Stimme ist schon gezählt.`;
export const wunschErfolgFirma = (referenz: string) => `Danke. Ihr Wunsch ${referenz} ist jetzt für Ihre Firma sichtbar.`;

// PF-312 (TEIL-3 SP3-07 „Soll Oberfläche“ mit BAU-HILFE.md 1.6): Wörter der Anfragen der Organisation. Die Überschrift ist
// anfragenDer({Organisation}); Statuswörter kommen aus ticketTexte.ts (Kundenseite, TEIL-3 1.0).
export const FIRMEN_TEXTE = {
  aktualisieren: 'Aktualisieren',
  // Name der Kennzahlen, des Zeitraums und des Status für Bildschirmleser.
  kennzahlenName: 'Kennzahlen',
  gesamt: 'Gesamt',
  offen: 'Offen',
  wartet: 'Wartet auf Ihre Antwort',
  geloest: 'Gelöst',
  zeitraumName: 'Zeitraum',
  zeitraum: { '12m': 'Letzte 12 Monate', jahr: 'Dieses Jahr', alle: 'Alle' },
  // F-23 (PF-NB-hilfe-3, Fehlersuche Nr. 26): kurz genug, dass der Platzhalter nicht abgeschnitten wird.
  suche: 'Betreff, Referenz oder Person',
  statusName: 'Status',
  // F-24 (PF-TX-hilfe-1, SPEC-hilfe-b 3.4 O2): „wartet“ mit demselben Wort wie die Kennzahl.
  status: { alle: 'Alle Status', offen: 'Offen', wartet: 'Wartet auf Ihre Antwort', geloest: 'Gelöst', geschlossen: 'Geschlossen' },
  spalteBetreff: 'Betreff',
  spaltePerson: 'Person',
  spalteEingegangen: 'Eingegangen',
  spalteStatus: 'Status',
  privat: 'Private Anfrage',
  // F-24 (PF-TX-hilfe-1, SPEC-hilfe-b 3.4 T-P): der Text des Tooltips hinter „Private Anfrage“ (früher das title-Attribut).
  privatTitel: 'Nur die Person und der Support sehen den Inhalt.',
  gefolgt: 'Gefolgt',
  // Wie backend/src/support/ticketAnsicht.ts GELOESCHTES_KONTO.
  geloeschtesKonto: 'Gelöschtes Konto',
  weitere: 'Weitere Anfragen laden',
  leer: 'Aus Ihrer Firma gibt es noch keine Anfragen.',
  leerGefiltert: 'Keine Anfrage passt zu Ihrer Auswahl.',
  laden: 'Anfragen werden geladen …',
  fehler: 'Die Anfragen sind gerade nicht erreichbar. Bitte versuchen Sie es in einigen Minuten erneut.',
  zurueck: 'Zurück zu den Anfragen',
  folgen: 'Folgen',
  folgenBeenden: 'Folgen beenden',
  // Im Detail aus der Firma (TicketDetail mit quelle „firma“).
  antwortHinweis: 'Ihre Antwort sehen die meldende Person und der Support.',
  wiederOeffnen: 'Wieder öffnen',
} as const;
/** Die meldende Person, wie der Server sie nennt: ausgetreten mit Zusatz, gelöscht als „Gelöschtes Konto“; keine Person: leer. */
export function firmenPerson(person: { name: string; stand: string } | null): string {
  if (!person) return '';
  if (person.stand === 'GELOESCHT') return FIRMEN_TEXTE.geloeschtesKonto;
  return person.stand === 'AUSGETRETEN' ? `${person.name} (nicht mehr in der Firma)` : person.name;
}

// PF-323 (BAU-HILFE.md 9.2 Punkt 2 wörtlich): Wörter der Neuigkeiten. Die Monatsüberschrift („Jänner 2027“) setzt Intl de-AT.
export const NEUIGKEITEN_TEXTE = {
  titel: 'Neuigkeiten',
  leer: 'Noch keine Neuigkeiten.',
  laden: 'Neuigkeiten werden geladen …',
  fehler: 'Die Neuigkeiten sind gerade nicht erreichbar. Bitte versuchen Sie es in einigen Minuten erneut.',
  kennzeichen: { NEU: 'Neu', BEHOBEN: 'Behoben' } as Record<string, string>,
} as const;
export const neuigkeitenBeschreibung = (produkt: string) => `Was sich in ${produkt} geändert hat.`;
export const neuigkeitenFuerVerwaltung = (organisation: string) => `Für die Verwaltung Ihrer ${organisation}`;

// PF-321-2 (BAU-HILFE.md 9.2 Punkt 4): die Zeile der oder des KI-Verantwortlichen auf „Dokumente“; organisation =
// brand.tenantLabel. F-23 (Standard F-23-rahmen-1): der Titel nimmt das Wort aus F-20 statt „Ansprechperson für KI“.
export const ANSPRECHPERSON = {
  titel: (organisation: string) => `KI-Verantwortliche:r Ihrer ${organisation}`,
  erklaerung: (name: string) => `${name} ist bei Ihnen für den Einsatz von KI zuständig.`,
  mail: 'E-Mail schreiben',
  anrufen: 'Anrufen',
} as const;

/** Titel des Browserfensters, solange die Seite offen ist. */
export const seitenTitel = (produkt: string) => `${MENUE.hilfeUndFeedback} · ${produkt}`;
/** Gruppentitel der Leiste: das Wort der Firma für „Organisation“ (brand.tenantLabel). */
export const organisationGruppe = (organisation: string) => organisation;
export const anfragenDer = (organisation: string) => `Anfragen der ${organisation}`;
export const keinTreffer = (suchtext: string) => `Keine Anleitung passt zu „${suchtext}“.`;
/** F-23 (PF-NB-hilfe-1): Zwischenüberschrift der Verwaltungsthemen; organisation = brand.tenantLabel. */
export const gruppeVerwaltung = (organisation: string) => `Für die Verwaltung Ihrer ${organisation}`;
export const ueberUndRecht = (produkt: string) => `Über ${produkt} und Recht`;
// F-23 (Nutzerblick Mitglied Z-05, Fehlersuche Nr. 8): der Abschnitt „Über … und Recht“ auf „Dokumente“ (UeberClairis.tsx).
// F-24 (PF-TX-hilfe-1, SPEC-hilfe-b 3.1 S1, T-B): der AVV-Satz in einem Satz; die Linkzeile „Neue Anfrage an den Support“ entfällt
// (die Hauptaktion steht im Seitenkopf); der Betriebshinweis nennt nur, was fehlt, der Weg dorthin steht im Tooltip.
export const UEBER_TEXTE = {
  produkt: 'Produkt',
  version: 'Version',
  anbieter: 'Anbieter',
  avvFirma: 'Verträge & AVV Ihrer Firma',
  avvKonto: 'AVV Ihres Kontos',
  avvSatz: 'Den Auftragsverarbeitungsvertrag (AVV) schließt die Verwaltung Ihrer Firma unter „Einstellungen der Firma“ › „Verträge & AVV“ ab.',
  betrieb: (fehlt: string[]) => `Für den Betrieb: Noch nicht hinterlegt: ${fehlt.join(', ')}.`,
  betriebWort: 'Noch nicht hinterlegt',
  betriebTipp: 'Datenschutzerklärung und Vertragsbedingungen veröffentlichen Sie unter „Rechtstexte“; die Adresse des Impressums legt die Installation fest.',
  rechtstexteOeffnen: 'Rechtstexte öffnen',
} as const;
/** „Über {Produktname}“: dasselbe Wort wie der Bereich im Pop-up (MK-1: immer CLAiRIS). */
export const ueber = EINSTELLUNGEN.ueber;
